var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright-content"},[_c('p',[_c('span',[_vm._v("版权所有© 杭州马兰头医学科技有限公司")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("浙ICP备2022002007号")])])])
}]

export { render, staticRenderFns }